/**
 * URLs do diretório público (`/profissionais/[categoria]/[cidade]`).
 * A cidade vira `nome-da-cidade-uf` (ex. `sao-paulo-sp`). Mesmo código na
 * função da Vercel (`api/directory-page.ts`) — o teste de SEO confere que os
 * dois geram o mesmo slug.
 */

export interface DirectoryEntry {
  categorySlug: string;
  categoryLabel: string;
  state: string | null;
  city: string | null;
  cityNormalized: string | null;
  providers: number;
}

export const citySlug = (cityNormalized: string, state: string): string =>
  `${cityNormalized
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')}-${state.toLowerCase()}`;

export const directoryPath = (entry: Pick<DirectoryEntry, 'categorySlug' | 'state' | 'cityNormalized'>) =>
  entry.state && entry.cityNormalized
    ? `/profissionais/${entry.categorySlug}/${citySlug(entry.cityNormalized, entry.state)}`
    : `/profissionais/${entry.categorySlug}`;
